<script setup lang="ts">
import { useCommonStore } from '@/stores/modules/common'
import { useUserStore } from '@/stores/modules/user'
import type { EternalTowerRankType } from '@/types/dungeon'
import { socketEmitAsync } from '@/utils/web-socket'
import { onMounted, ref } from 'vue'

const commonStore = useCommonStore()
const userStore = useUserStore()

const eternalTowerRank = ref<EternalTowerRankType[]>([])
async function getEternalTowerRank() {
  const res = await socketEmitAsync<EternalTowerRankType[]>({ type: 'getEternalTowerRank' })
  eternalTowerRank.value = res
}
const refreshTime = ref(0)
function handleRefresh() {
  refreshTime.value = 60
  const interval = setInterval(() => {
    refreshTime.value--
    if (refreshTime.value <= 0) clearInterval(interval)
  }, 1000)
  getEternalTowerRank()
}

onMounted(() => {
  getEternalTowerRank()
})
</script>

<template>
  <div class="eternal-tower-rank">
    <h4>不朽之塔排行</h4>
    <el-button size="small" type="primary" plain @click="handleRefresh" style="margin-bottom: 10px" :disabled="refreshTime > 0">
      {{ refreshTime > 0 ? `请等待（${refreshTime}s）` : '刷新' }}
    </el-button>
    <el-table
      :data="eternalTowerRank"
      border
      style="width: 100%; height: 49vh"
      :row-class-name="({ row }: any) => (row.id === userStore.id ? 'personal' : '')"
      size="small"
      v-loading="commonStore.loading"
    >
      <el-table-column prop="rank" label="排位" width="50">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="昵称">
        <template #default="{ row }">
          <span class="nickname" :style="{ background: row.color }">{{ row.nickname }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="level" label="层数" width="70" />
      <el-table-column prop="hpPercent" label="击破比例" width="70">
        <template #default="{ row }"> {{ row.hpPercent }}% </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss" scoped>
.eternal-tower-rank {
  :deep() {
    .el-table {
      .personal {
        --el-table-tr-bg-color: var(--el-color-danger-light-7);
      }
    }
  }
}
</style>
